import { urlUtility } from "@repo/utilities/url.utility.ts";
import {
  createSearchParams,
  NavigateOptions,
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";

export default function useRoutesHandler() {
  // url queries
  const navigate = useNavigate();
  const route = useParams();
  const location = useLocation();
  const [searchParams, setSearchParams] = useSearchParams();
  const urlQueries = urlUtility.getUrlQueries(location.search);

  // FUNCTIONS
  const navigateTo = ({
    url,
    search,
    ...options
  }: {
    url?: string;
    search?: Record<string, string>;
  } & NavigateOptions) => {
    navigate(
      {
        pathname: url,
        search: createSearchParams({
          ...urlQueries,
          ...search,
        }).toString(),
      },
      options
    );
  };

  const navigateBackTo = ({
    searchKey,
    to,
  }: {
    searchKey: string | string[];
    to?: Record<string, string>;
  }) => {
    const urlObject = urlQueries;

    if (Array.isArray(searchKey)) {
      searchKey.forEach((keyString) => {
        delete urlObject[keyString];
      });
    } else {
      delete urlObject[searchKey];
    }

    navigate({
      search: createSearchParams({
        ...urlObject,
        ...to,
      }).toString(),
    });
  };

  // VARIABLES
  const activeRoutes = location.pathname?.split("/");
  const subRoute = activeRoutes[activeRoutes.length - 1];

  return {
    searchParams,
    setSearchParams,
    activeRoutes,
    subRoute,
    route,
    location,
    urlQueries,
    navigate,
    navigateTo,
    navigateBackTo,
  };
}
